export class BankTransactionDashboardFilter {
  CompanyId?: number;

  constructor() {
    this.CompanyId = null;
  }
}
